import { UrlConstants } from "../url.constants";
export class ApiStreetNamingConstants {
    static URL = UrlConstants.API_V2 + "StreetNaming";
    static FUNCTION_CREATE_PARTIAL_APPLICATION = "CreatePartialPortalStreetNamingApplication";
    static FUNCTION_CREATE_RESUBMITTED_APPLICATION = "CreateResubmittedPortalStreetNamingApplication";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetStreetNamingApplicantAndApplicantAgent";
    static FUNCTION_GET_GENERATE_INVOICE = "GenerateStreetNamingInvoiceReport";
    static FUNCTION_SET_PROPERTIES = "SetStreetNamingLocation";
    static FUNCTION_GET_MY_AFLA_PORTAL_INFORMAL_TRADING_APPLICATIONS = "GetMyAFLAPortalStreetNamingApplications";
    static FUNCTION_GET_ALL_AFLA_PORTAL_STREET_NAMING_APPLICATIONS = "GetAllAFLAPortalStreetNamingApplications";
    static FUNCTION_GET_APPLICATION_TYPE = "GetStreetNamingApplicationTypes";
}
